// extracted by mini-css-extract-plugin
export var emailBlockLink = "_ku-0";